import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import difitek from '../images/difitek.png';
import backoffice from '../images/backofficeapp.png'
import reactlogo from '../images/React-logo.png'
import mitlicense from '../images/mitlicense.png'
import versioning from '../images/versioning.png'
import admintasks from '../images/admintasks.png'

export default class Backoffice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
    };
  }

  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      return;
    }

    this.setState({ isLoading: false });
  }

  render() {
    return (
      <div className="container">
        <Row>
          <Col md={6}>
            <h1>Backoffice App</h1>
            <p>Open source backoffice application built in ReactJS. Run our hosted version or deploy in your own environment. Out-of-the-box functionality for common admin tasks including:
              <br />
              <br />
              <ul>
                <li>Stakeholder Management</li>
                <li>Asset Managemnt</li>
                <li>User Management</li>
                <li>Stakeholder Communication</li>
                <li>Fund Distribution</li>
                <li>Much more...</li>
              </ul>                      
            </p>
          </Col>
          <Col md={6}>
            <img alt="" src={backoffice} />
          </Col>
        </Row>
        <div className="container darkpanel">
          <Row>
            <Col md={6}>
            <h1>Out-of-the-box solution for common administrative tasks</h1>
            <p>Fintech applications share many common administrative requirements. Avoid re-inventing the wheel by using our backoffice application.</p>
            </Col>
            <Col md={6}>
              <img alt="" className="panelimg" src={admintasks} />
            </Col>
          </Row>
        </div>
        <div className="container lightpanel">
          <Row>
            <Col md={6}>
              <img alt="" className="panelimg" src={mitlicense} />
            </Col>
            <Col md={6}>
              <h1>Open Source</h1>
              <p>The MIT licensed backoffice allows you to freely fork the application and further extend the functionality either for internal use, or create a monetized version.</p>
            </Col>
          </Row>
        </div>
        <div className="container darkpanel">
          <Row>
            <Col md={6}>
            <h1>Shared Maintenance and Versioning</h1>
            <p>Never worry about versioning again, host a specific version or use our hosted application to use the latest updates. Any improvements made by us or our partners will automatically become available to you as they are released.</p>
            </Col>
            <Col md={6}>
              <img alt="" className="panelimg" src={versioning} />
            </Col>
          </Row>
        </div>
        <div className="container lightpanel">
          <Row>
            <Col md={6}>
              <img alt="" className="panelimg" src={reactlogo} />
            </Col>
            <Col md={6}>
              <h1>Modern Application Framework</h1>
              <p>The application is built using ReactJS in combination with the most up-to-date dependencies. Rest assured that your admin application is scalable and future-proof.</p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
